import { ReactNode, useEffect } from 'react';

import shallow from 'zustand/shallow';

import { useCurrentUser } from 'api/authentication/hooks';

import { useJourneyPresence } from '../hooks/use-journey-presence';
import { presenceStore } from '../hooks/use-journey-presence-store';

export const PresenceProvider = ({
  journeyId,
  children,
}: {
  journeyId?: string;
  children: ReactNode;
}) => {
  const currentUser = useCurrentUser();
  const { sendActionOpened, sendActionClosed } = useJourneyPresence(journeyId || '');

  useEffect(() => {
    presenceStore.setCurrentUserId(currentUser?.shortId);
  }, [currentUser?.shortId]);

  useEffect(() => {
    presenceStore.setSendFunctions(sendActionOpened, sendActionClosed);
  }, [sendActionOpened, sendActionClosed]);

  return <>{children}</>;
};

export const usePresence = () => {
  return presenceStore.useStore(
    (state) => ({
      activeUsers: state.activeUsers,
      actionEditors: state.actionEditors,
      currentUserId: state.currentUserId,
      sendActionOpened: state.sendActionOpened,
      sendActionClosed: state.sendActionClosed,
    }),
    shallow,
  );
};
